export default __webpack_public_path__ + "static/media/full_logo.1010855b.svg";